<!--
  +---------------------------------------------------------------------------------------
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     增值模块开通
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-card class="mt-lg mb-lg ei-apply" :body-style="{ margin: '0 100px', width: '1080px' }" shadow="never">
    <div class="mt mb">
      <el-steps :active="active" finish-status="success" process-status="finish" align-center>
        <el-step title="同意协议"></el-step>
        <el-step title="填写资料"></el-step>
        <el-step title="等待审核"></el-step>
      </el-steps>
    </div>
    <div v-if="active == 0">
      <div class="card-content1">
        <el-scrollbar>
          <h3 class="text-center mt-lg mb-lg">{{ title }}</h3>
          <div class="text-justify">
            <p v-for="(item,i) in content" :key="i" v-html="item"></p>
          </div>
        </el-scrollbar>
      </div>
      <div class="mt-lg">
        <div>
          <el-checkbox v-model="checked">我同意并遵守上述的《{{ title }}》</el-checkbox>
        </div>
        <div class="flex-center mt-lg mb-xm">
          <el-button type="success" :disabled="disabled" @click="next">下一步</el-button>
        </div>
      </div>
    </div>
    <div v-else-if="active == 1">
      <div class="card-content2 pt-xm">
        <p class="border-bottom">对公账户信息</p>
        <el-form ref="accountform" :inline-message="true" :hide-required-asterisk="true" label-position="left" label-width="150px" :model="accountform" :rules="accountformRules">
          <el-form-item label="开户名称" prop="name">
            <el-col :span="12">
              <el-input v-model="accountform.name" placeholder="请输入开户名称" clearable size="mini"></el-input>
              <p class="font-sm text-muted remarks">对公账户需要跟主体证件上的机构名称保持一致；企业是必须要有对公账户的，若无对公账户请先办理对公账户。</p>
            </el-col>
          </el-form-item>
          <el-form-item label="开户银行" prop="bank">
            <el-col :span="12">
              <el-input v-model="accountform.bank" placeholder="请输入开户银行（具体支行）" clearable size="mini"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="账户银行账号" prop="num">
            <el-col :span="12">
              <el-input v-model="accountform.num" placeholder="请输入正确的银行账号" clearable size="mini"></el-input>
            </el-col>
          </el-form-item>
          <p class="mt-hg border-bottom">申请公函下载填写</p>
          <div class="flex align-items-center mt">
            <span class="title text-muted">申请公函</span>
            <div>
              <p class="font-sm text-muted">上传加盖公章的申请公函图片；<el-link class="font-sm" :underline="false" type="success" :href="file.url" target="_Blank">下载公函模板</el-link></p>
              <p class="font-sm text-muted ">请确保申请公函图片所有信息清晰可见，内容真实有效，无任何修改；</p>
              <p class="font-sm text-muted">图片大小不超过2M，格式支持 .jpg .png。</p>
              <div class="flex align-items-center">
                <span class="font-sm text-muted">示例图片：</span>
                <el-image
                  class="border"
                  style="width: 21px; height: 28.5px"
                  :src="url"
                  :preview-src-list="urlList" />
              </div>
            </div>
          </div>
          <el-form-item label="上传图片" prop="pic" class="mt-lg">
            <f-image-card-uploader :files="picture" :limit="1" aimPath="certify/" @change="imageUpload" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flex-center mt-lg mb-lg">
        <el-button type="success" @click="submit">提交审核</el-button>
      </div>
    </div>
    <div v-else-if="active == 2">
      <div class="flex-center column card-content3">
        <div class="font-6x text-success">
          <i class="iconfont icon-circle-check"></i>
        </div>
        <div class="mt-sm font-lg text-success">资料提交成功，正在为你审核……</div>
        <p class="font-md">你提交的资料，将在1-3个工作日之内审核完成，请耐心等待。</p>
        <el-button class="mt-lg" type="success" @click="finish">完成（{{ count }}）</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { eiProtocolApi, eiGetfileApi, eiSendApi } from '@/api/ei/eiApplyApi'
import { moduleOpenStatus } from '@/api/common/moduleApi'

export default {
  name: 'EiApply',

  components: {
    FImageCardUploader: () => import('@/components/FImageCardUploader'),
  },

  props: {},

  data() {
    var validatePicture = (rule, value, callback) => {
      if (this.accountform.pic === '') {
        callback(new Error('请上传申请公函照片'))
      } else {
        callback()
      }
    }

    return {
      file: {},
      active: 0,
      title: '',
      content: [],
      checked: false,
      disabled: true,
      module: {},
      accountform: {
        name: '',
        bank: '',
        num: '',
        pic: '',
      },
      accountformRules: {
        name: [
          { required: true, message: '请填写开户名称', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请填写开户银行', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请填写银行账号', trigger: 'blur' },
        ],
        pic: [
          { validator: validatePicture, trigger: 'blur' }
        ]
      },
      url: require('@/assets/protocol.jpg'),
      urlList: [require('@/assets/protocol.jpg')],
      count: 5,
      timer: null
    }
  },

  computed: {
    picture() {
      const arr = []
      if (!this.accountform.pic) {
        return []
      }
      arr.push({
        url: this.accountform.pic
      })
      return arr
    },
  },

  watch: {
    checked: function() {
      this.disabled = !this.disabled
    }
  },

  created() {
    this.getProtocol()
    this.getFile()
    moduleOpenStatus({ module: 'Ei' }).then(res => {
      this.module = Object.assign({}, res.data.module)
    })
  },

  beforeDestroy() {},

  methods: {
    getFile() {
      eiGetfileApi().then(res => {
        if (!res.errno) {
          this.file = Object.assign({}, res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getProtocol() {
      eiProtocolApi().then(res => {
        this.title = res.message
        this.content = res.data
      }).catch(() => {

      })
    },
    next() {
      if (this.checked && this.active === 0) {
        this.active = 1
      } else {
        this.$message.warning('尚未勾选同意并遵守《设备增值协议》')
      }
    },
    imageUpload(arr) {
      this.accountform.pic = arr.length === 0 ? '' : arr[0].url
      this.clear()
    },
    clear() {
      this.$nextTick(() => {
        this.$refs['accountform'].clearValidate()
      })
    },
    submit() {
      this.$refs['accountform'].validate(valid => {
        if (valid) {
          const obj = {
            module: 'Ei',
            account_name: this.accountform.name,
            bank: this.accountform.bank,
            bank_number: this.accountform.num,
            url_name: this.accountform.pic
          }
          eiSendApi(obj).then(res => {
            if (!res.errno) {
              this.active = 2
              moduleOpenStatus({ module: 'Ei' }).then(res => {
                this.module = Object.assign({}, res.data.module)
                this.timer = setInterval(() => {
                  this.count -= 1
                  if (this.count <= 0) {
                    this.finish()
                  }
                }, 1000)
              })
            } else {
              this.$message.error(res.message)
            }
          }).catch(() => {
          })
        }
      })
    },
    finish() {
      clearInterval(this.timer)
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.ei-apply{
  .el-scrollbar {
    height: 100%;
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 50px;
      }
    }
  }
  .el-steps {
    width: 100%;
  }
  .border{
    border: 1px solid #ccc;
  }
}
.card-content1{
  width: 100%;
  height: 560px;
  overflow: hidden;
  border: 1px solid #c0c4cc;
}
.card-content2{
  width: 100%;
  height: 575px;
  .border-bottom{
    padding-bottom: 5px;
    border-bottom: 1px solid #c0c4cc;
  }
  .title{
    display: block;
    width: 150px;
  }
  .remarks{
    display: block;
    line-height: 20px;
    text-align: justify;
  }
  a:hover{
    color: #409eff;
  }
}
.card-content3{
  width: 100%;
  height: 670px;
}
</style>
